import { gql } from '@apollo/client'

export const GET_SERVICE_LINE_ITEMS = gql`
  query GetServiceLineItems($orderNumber: String!) {
    order(number: $orderNumber) {
      id
      serviceLineItems (scopeType: "as_main_items") {
        edges {
          node {
            id
            quantity
            name
            unit
            cost
            singlePrice
            totalPrice
          }
        }
      }
    }
  }
`